import type { ComponentProps } from 'react';
import type { TextInputProps } from 'react-native';
import type { Box } from '../../Box';

export interface InputProps extends Omit<TextInputProps, 'value'> {
  defaultLines?: number;
}

export interface TextAreaProps extends ComponentProps<typeof Box> {
  label: string;
  input?: InputProps;
  heightContainer?: number;
}

export interface TextAreaRef {
  setImperativeValue: (v: string) => void;
}
